"use server";

import { prisma } from "@/lib/prisma";
import { cookies, headers } from "next/headers";
import { decrypt } from "@/lib/auth";
import { getSettings } from "@/lib/settings";
import { revalidatePath } from "next/cache";

// Yardımcı: Admin oturumunu kontrol et
async function getTenantSession() {
    const cookieStore = await cookies();
    const sessionToken = cookieStore.get("tenant_session")?.value;
    if (!sessionToken) return null;
    const decoded = await decrypt(sessionToken);
    if (!decoded || !decoded.siteId) return null;
    return decoded;
}

// --- MÜŞTERİ (DIŞ) İŞLEMLERİ ---

export async function submitCancellationAction(data: { branch: string, identity: string, plate: string, phone: string, note?: string, pdfUrl: string }) {
    try {

        if (!data.pdfUrl) {
            return { success: false, error: "Sistemsel Hata: PDF dosya yolu (pdfUrl) bulunamadı." };
        }

        const headersList = await headers();
        const domain = headersList.get("host")?.split(":")[0] || "";
        const settings = await getSettings(domain);

        if (!settings) return { success: false, error: "Sistem yapılandırma hatası." };

        await prisma.cancellationRequest.create({
            data: {
                siteId: settings.siteId,
                branch: data.branch,
                identity: data.identity,
                plate: data.plate.toUpperCase(),
                phone: data.phone,
                pdfUrl: data.pdfUrl,
                note: data.note,
                status: "Bekliyor"
            }
        });

        // Admin paneline düşmesi için cache temizle
        revalidatePath(`/[domain]/admin/iptal-talepleri`, 'page');
        return { success: true };
    } catch (error) {
        console.error("Talep Oluşturma Hatası:", error);
        return { success: false, error: "Talebiniz alınırken bir hata oluştu." };
    }
}

export async function trackCancellationAction(data: { branch: string, identity: string, phone: string }) {
    try {
        const headersList = await headers();
        const domain = headersList.get("host")?.split(":")[0] || "";
        const settings = await getSettings(domain);
        if (!settings) return { success: false, error: "Sistem hatası." };

        const request = await prisma.cancellationRequest.findFirst({
            where: {
                siteId: settings.siteId,
                branch: data.branch,
                identity: data.identity,
                phone: data.phone
            },
            orderBy: { createdAt: 'desc' }, // En son talebi getir
            select: { status: true, plate: true, branch: true, createdAt: true } // Güvenlik için sadece bu alanları döndür
        });

        if (!request) return { success: false, error: "Bu bilgilere ait bir talep bulunamadı." };

        return { success: true, data: request };
    } catch (error) {
        return { success: false, error: "Sorgulama sırasında hata oluştu." };
    }
}


// --- ADMİN (İÇ) İŞLEMLERİ ---

export async function getAdminCancellationsAction() {
    try {
        const session = await getTenantSession();
        if (!session) return { success: false, error: "Yetkisiz işlem." };

        const requests = await prisma.cancellationRequest.findMany({
            where: { siteId: session.siteId },
            orderBy: { createdAt: 'desc' }
        });

        return { success: true, data: requests };
    } catch (error) {
        return { success: false, error: "Talepler yüklenemedi." };
    }
}

export async function updateCancellationStatusAction(id: string, status: string) {
    try {
        const session = await getTenantSession();
        if (!session) return { success: false, error: "Yetkisiz işlem." };

        await prisma.cancellationRequest.update({
            where: { id: id, siteId: session.siteId },
            data: { status: status }
        });

        revalidatePath(`/[domain]/admin/iptal-talepleri`, 'page');
        return { success: true };
    } catch (error) {
        return { success: false, error: "Durum güncellenemedi." };
    }
}